import { Badge } from "baseui/badge"
import { FormattedMessage } from "react-intl"
import { IDriveVarSpeed } from "./types"


export interface AggregateVarStateTextProps extends IDriveVarSpeed
{   
    dontShowOff?: boolean
}
export const AggregateVarStateText = (props: AggregateVarStateTextProps) => {

    const speed = getSpeedFromFanVar(props) ?? 0;
    const speedTrimmed = Number(speed).toFixed(0)
    return (<>
        {props.isOn && <Badge hierarchy='secondary' color='positive' content={`${speedTrimmed} %`} />}
            {(!props.isOn && !props.dontShowOff) && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="OFF" />} />}
    </>)
}

const getSpeedFromFanVar = (fan: any) => {
    if (!fan)
            return undefined;
    if (fan.actSpeed)
            return fan.actSpeed;
    if (fan.setSpeed)
            return fan.setSpeed;
}